"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuPanelContainer;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
require("./index.scss");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function MenuPanelContainer({
  data,
  children,
  commonStyle,
  domains: domainInfos
}) {
  const color = data.color,
    gradientColor = data.gradientColor;
  const bgStyle = {};
  if (color) {
    bgStyle['backgroundColor'] = color;
  }
  if (gradientColor) {
    bgStyle['backgroundImage'] = gradientColor;
  }
  const renderChild = child => {
    return child ? /*#__PURE__*/React.cloneElement(child, {
      domains: domainInfos,
      className: 'component-banner-offset-top'
    }) : child;
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "banner-offset-container",
    id: "banner-offset-container",
    style: bgStyle
  }, React.Children.map(children, (child, index) => /*#__PURE__*/React.createElement("div", {
    className: "banner-offset-child",
    style: commonStyle,
    key: index,
    id: `banner-offset-container-child-${index}`
  }, renderChild(child))));
}